import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  VERIFY_2F,
  VERIFY_2F_SUCCESS,
  VERIFY_2F_LOGIN,
  VERIFY_2F_LOGIN_SUCCESS

} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const verify2fCode = (verify, history) => {
  return {
    type: VERIFY_2F,
    payload: { verify, history },
  }
}

export const verify2fCodeSuccess = verify => {
  return {
    type: VERIFY_2F_SUCCESS,
    payload: verify,
  }
}

export const verify2fLogin = (verify, history) => {
  return {
    type: VERIFY_2F_LOGIN,
    payload: { verify, history },
  }
}

export const verify2fLoginSuccess = verify => {
  return {
    type: VERIFY_2F_LOGIN_SUCCESS,
    payload: verify,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}
